import RefFlavorIntensityPqChart from './RefFlavorIntensityPqChart';
export default RefFlavorIntensityPqChart;